<template>
  <select
    v-bind:name="name"
    v-bind:id="name"
    v-on:change="onChange"
    class="no-autoinit"
  >
    <option
      v-bind:key="city.code"
      v-bind:disabled="city.code == disabled"
      v-bind:value="city.code"
      v-bind:selected="city.code == selected ? 'selected' : ''"
      v-for="city in cities"
    >
      {{ city.name }}
    </option>
  </select>
</template>


<script>
import axios from "axios";
import M from "materialize-css";
import API from "../api.js";

export default {
  props: {
    name: String,
    text: String,
    selected: String,
  },
  data() {
    return {
      cities: null,
      disabled: String,
    };
  },
  mounted() {
    axios.get(API.cities).then((resp) => {
      this.cities = resp.data.cities;
    });

    // values received from other InputCities
    // will be disabled here...
    this.$root.$on("cityChanged", (val, el) => {
      if (el.name != this.name) {
        this.disabled = val;
      }
    });
  },
  updated() {
    M.FormSelect.init(document.querySelector("#" + this.name), {
      dropdownOptions: { container: "body" },
    });
    this.onChange();
  },
  methods: {
    onChange() {
      this.$root.$emit("cityChanged", this.$el.value, this.$el); // for internal use (disabling previously selected cities in other fields)
      this.$emit("input", this.$el.value); // for v-model
    },
  },
};
</script>